import PageLayout from 'pages/QuizGrading/PageLayout';
import PageProvider from 'pages/QuizGrading/PageProvider';

const QuizGradingPage = () => (
    <PageProvider>
        <PageLayout />
    </PageProvider>
);

export default QuizGradingPage;
